import { render, staticRenderFns } from "./WxUserListModal.vue?vue&type=template&id=4669be72&scoped=true&"
import script from "./WxUserListModal.vue?vue&type=script&lang=js&"
export * from "./WxUserListModal.vue?vue&type=script&lang=js&"
import style0 from "./WxUserListModal.vue?vue&type=style&index=0&id=4669be72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4669be72",
  null
  
)

export default component.exports